module.exports = __webpack_public_path__ + "img/falkland-islands.a5e298cc.svg";